$(document).ready(function () {
  setTimeout(function () {
    $(".main-carousel").flickity({
      cellAlign: "center",
      groupCells: true,
      contain: true,
      prevNextButtons: false,
      dots: false,
    });
  }, 4000);

  // FAQ Section
  $(".faq-title").click(function () {
    $(this).toggleClass("active");
    $(this).parent().find(".faq-content").slideToggle();
  });

  // Footer Menu
  $(".footer-menu-link").click(function () {
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 1125) {
      $(this).children(".footer-blocks-content").slideToggle();
    }
  });

  // Product Tabs
  $("ul.shopify-tabs > li").click(function () {
    var tab_id = $(this).attr("data-tab");
    $(this).parent().find("li").removeClass("current");
    $(".shopify-tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  //Product Page logic
  if ($(".sealsubs-target-element") != null) {
    $(document).on("click", ".sls-option-container", function () {
      setTimeout(function () {
        var type = $(".sls-option:checked").data("type");
        $(".product-form__buttons").show();
        if (type == "subscription") {
          if ($(".bundle-widget-block") != null) {
            $(".bundle-widget-block").hide();
            $(".product-form__quantity").hide();
          }
          $(".quantity__input").val(1);
        } else {
          if ($(".bundle-widget-block") != null) {
            $(".bundle-widget-block").show();
            $(".ast-vd-option").removeClass("ast-vd-option-active");
            $(".product-form__quantity").show();
          }
        }
      }, 300);
    });
  }

  $(document).on("change", ".quantity__input", function () {
    if ($(".sealsubs-target-element").data("product-id") == 4639160238128) {
      console.log($(this).val());
      var subscriptionType = $(".sls-option:checked").data("type");
      if (subscriptionType != "undefined") {
        if (subscriptionType == "one_time") {
          var basUrl = window.location.origin + "/products/";
          // setTimeout(function () {
          //   if ($(".quantity__input").val() == "2") {
          //     $(".product-form__buttons").hide();
          //     window.location.href =
          //       basUrl + "beauty-vitamin-gummies-2-month-bundle";
          //     //console.log('Redirect on '+ basUrl+'beauty-vitamin-gummies-2-month-bundle');
          //   } else if ($(".quantity__input").val() == "3") {
          //     $(".product-form__buttons").hide();
          //     window.location.href =
          //       basUrl + "beauty-vitamin-gummies-3-month-eco-bundl";
          //     //console.log('Redirect on '+ basUrl+'beauty-vitamin-gummies-3-month-eco-bundl');
          //   } else if ($(".quantity__input").val() == "4") {
          //     $(".product-form__buttons").hide();
          //     window.location.href =
          //       basUrl + "beauty-vitamin-gummies-4-month-bundle";
          //     //console.log('Redirect on '+ basUrl+'beauty-vitamin-gummies-4-month-bundle');
          //   } else {
          //     $(".product-form__buttons").show();
          //   }
          // }, 300);
          setTimeout(function () {
            if ($(".quantity__input").val() == "3") {
              $(".product-form__buttons").hide();
              window.location.href =
                basUrl + "beauty-vitamin-gummies-3-month-eco-bundl";
              //console.log('Redirect on '+ basUrl+'beauty-vitamin-gummies-3-month-eco-bundl');
            } else if ($(".quantity__input").val() == "4") {
              $(".product-form__buttons").hide();
              window.location.href =
                basUrl + "beauty-vitamin-gummies-4-month-bundle";
              //console.log('Redirect on '+ basUrl+'beauty-vitamin-gummies-4-month-bundle');
            } else {
              $(".product-form__buttons").show();
            }
          }, 300);
        }
      }
    }
  });
  function updatecartData() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        var cartData = cart;
        if (cartData.items) {
          var itemData = cartData.items;
          itemData.map(function (element) {
            if (
              element.selling_plan_allocation != undefined &&
              element.id == 41151188238514 &&
              element.quantity > 1
            ) {
              $(".info-message").css("display", "block");
              $(".checkout-btn").css("display", "none");
            } else if (
              element.selling_plan_allocation != undefined &&
              element.id == 41151188238514 &&
              element.quantity == 1
            ) {
              $(".info-message").css("display", "none");
              $(".checkout-btn").css("display", "block");
            }
          });
        }
      });
    //}, 50);
  }
  $(document).on("change", "input[name='updates[]']", function () {
    updatecartData();
  });
  $(document).on("click", ".subscription-product", function () {
    $(".info-message").css("display", "none");
    $(".checkout-btn").css("display", "block");
  });

  // PR Banner Slider
  const logoSwiper = new Swiper(".logo-slider", {
    loop: false,
    slidesPerView: 2,
    spaceBetween: 10,

    autoplay: {
      delay: 2000,
    },
    navigation: false,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      990: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });

  // Rich Text
  // let slides = $(".rich-text__blocks .flickity-slider");
  // let prevArrow = $(".rich-text-content-wrapper .flickity-button.previous");
  // let nextArrow = $(".rich-text-content-wrapper .flickity-button.next");

  // if (slides.children().length < 2) {
  //   // prevArrow.hide();
  //   // nextArrow.hide();
  //   console.log(slides.children().length)
  //   $('.rich-text-content-wrapper .flickity-button').css("display", "none")
  // } else {
  //   console.log("test")
  //   console.log(slides.children().length)
  //   $('.rich-text-content-wrapper .flickity-button').css("display", "block")
  //   // prevArrow.show();
  //   // nextArrow.show();
  // }

  $(".rich-text-content-wrapper").each(function () {
    let section = $(this);
    let slidesContainer = section.find(".rich-text__blocks .flickity-slider");
    let slides = slidesContainer.children();
    let prevArrow = section.find(".flickity-button.previous");
    let nextArrow = section.find(".flickity-button.next");

    if (slides.length <= 1) {
      prevArrow.hide();
      nextArrow.hide();
    } else {
      prevArrow.show();
      nextArrow.show();
    }
  });

  // Best Rated
  const bestRatedswiper = new Swiper(".best-rated-products", {
    slidesPerView: 1.2,
    spaceBetween: 20,
    loop: false,
    breakpoints: {
      660: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  // Image Banner Icons
  const imageBannerIcons = new Swiper(".image-banner-icons", {
    slidesPerView: 2.5,
    autoplay: {
      delay: 2000,
    },

    breakpoints: {
      565: {
        slidesPerView: 4,
      },
      450: {
        slidesPerView: 3,
      },
    },
  });

  // FAQ Accordion
  $(".faq-item").not(":first").find(".faq-answer").hide();
  $(".faq-item").first().addClass("active");
  $(".faq-item").first().find(".minus-icon").removeClass("active");
  $(".faq-item").first().find(".plus-icon").addClass("active");

  $(".faq-question").on("click", function () {
    let content = $(this).next(".faq-answer");

    if ($(this).parent().hasClass("active")) {
      content.slideUp();
      $(this).parent().removeClass("active");
      $(this).find(".minus-icon").addClass("active");
      $(this).find(".plus-icon").removeClass("active");
    } else {
      content.slideDown();
      $(this).parent().addClass("active");
      $(this).find(".minus-icon").removeClass("active");
      $(this).find(".plus-icon").addClass("active");

      $(".faq-item")
        .not($(this).parent())
        .each(function () {
          $(this).removeClass("active");
          $(this).find(".faq-answer").slideUp();
          $(this).find(".minus-icon").addClass("active");
          $(this).find(".plus-icon").removeClass("active");
        });
    }
  });

  // Exclusive Benefits
  const exclusiveBenefitsswiper = new Swiper(".swiper-benefits-container", {
    loop: false,
    slidesPerView: 1,
    pagination: {
      el: ".benefits-list .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      660: {
        slidesPerView: 2,
        // spaceBetween: 10,
      },
      990: {
        slidesPerView: 3,
        // spaceBetween: 10,
      },
    },
  });

  // Customer Image Slider
  // const customerImageSwiper = new Swiper(".swiper-customer-images", {
  //   loop: false,
  //   slidesPerView: 2,
  //   spaceBetween: 10,
  //   navigation: {
  //     prevEl: ".customer-image-slider-wrapper .swiper-button-prev",
  //     nextEl: ".customer-image-slider-wrapper .swiper-button-next",
  //   },
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 3,
  //       spaceBetween: 10,
  //       navigation: {
  //         prevEl: ".customer-image-slider-wrapper .swiper-button-prev",
  //         nextEl: ".customer-image-slider-wrapper .swiper-button-next",
  //       },
  //     },
  //     990: {
  //       slidesPerView: 4,
  //       spaceBetween: 10,
  //       navigation: {
  //         prevEl: ".customer-image-slider-wrapper .swiper-button-prev",
  //         nextEl: ".customer-image-slider-wrapper .swiper-button-next",
  //       },
  //     },
  //     1200: {
  //       slidesPerView: 5,
  //       spaceBetween: 10,
  //       navigation: {
  //         prevEl: ".customer-image-slider-wrapper .swiper-button-prev",
  //         nextEl: ".customer-image-slider-wrapper .swiper-button-next",
  //       },
  //     },
  //   },
  //   on: {
  //     init: function () {
  //       toggleNavigation(this);
  //     },
  //     resize: function () {
  //       toggleNavigation(this);
  //     },
  //     slideChange: function () {
  //       toggleNavigation(this);
  //     },
  //   },
  // });

  // function toggleNavigation(swiperInstance) {
  //   const totalSlides = swiperInstance.slides.length;
  //   let slidesPerView = swiperInstance.params.slidesPerView;

  //   if (typeof slidesPerView === "object") {
  //     const windowWidth = $(window).width();
  //     for (const bp in swiperInstance.params.breakpoints) {
  //       if (windowWidth >= bp) {
  //         slidesPerView = swiperInstance.params.breakpoints[bp].slidesPerView;
  //       }
  //     }
  //   }

  //   const navButtons = $(
  //     ".customer-image-slider-wrapper .swiper-button-prev, .customer-image-slider-wrapper .swiper-button-next"
  //   );
  //   slidesPerView = slidesPerView === "auto" ? totalSlides : slidesPerView;

  //   if (totalSlides === slidesPerView) {
  //     navButtons.css("display", "none");
  //   } else {
  //     navButtons.css("display", "block");
  //   }
  // }

  $(".customer-image-slider-wrapper").each(function () {
    var uniqueId = $(this).data("id"); // Get unique ID for the section

    // Initialize Swiper for each specific customer image slider section
    var customerImageSwiper = new Swiper(
      '.swiper-container.swiper-customer-images[data-id="' + uniqueId + '"]',
      {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
          prevEl:
            '.customer-image-slider-wrapper[data-id="' +
            uniqueId +
            '"] .swiper-button-prev',
          nextEl:
            '.customer-image-slider-wrapper[data-id="' +
            uniqueId +
            '"] .swiper-button-next',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
            navigation: {
              prevEl:
                '.customer-image-slider-wrapper[data-id="' +
                uniqueId +
                '"] .swiper-button-prev',
              nextEl:
                '.customer-image-slider-wrapper[data-id="' +
                uniqueId +
                '"] .swiper-button-next',
            },
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 10,
            navigation: {
              prevEl:
                '.customer-image-slider-wrapper[data-id="' +
                uniqueId +
                '"] .swiper-button-prev',
              nextEl:
                '.customer-image-slider-wrapper[data-id="' +
                uniqueId +
                '"] .swiper-button-next',
            },
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 10,
            navigation: {
              prevEl:
                '.customer-image-slider-wrapper[data-id="' +
                uniqueId +
                '"] .swiper-button-prev',
              nextEl:
                '.customer-image-slider-wrapper[data-id="' +
                uniqueId +
                '"] .swiper-button-next',
            },
          },
        },
        on: {
          init: function () {
            toggleNavigation(this, uniqueId);
          },
          resize: function () {
            toggleNavigation(this, uniqueId);
          },
          slideChange: function () {
            toggleNavigation(this, uniqueId);
          },
        },
      }
    );
  });

  // Function to toggle navigation visibility based on the number of slides
  function toggleNavigation(swiperInstance, uniqueId) {
    const totalSlides = swiperInstance.slides.length;
    let slidesPerView = swiperInstance.params.slidesPerView;

    if (typeof slidesPerView === "object") {
      const windowWidth = $(window).width();
      for (const bp in swiperInstance.params.breakpoints) {
        if (windowWidth >= bp) {
          slidesPerView = swiperInstance.params.breakpoints[bp].slidesPerView;
        }
      }
    }

    const navButtons = $(
      '.customer-image-slider-wrapper[data-id="' +
        uniqueId +
        '"] .swiper-button-prev, ' +
        '.customer-image-slider-wrapper[data-id="' +
        uniqueId +
        '"] .swiper-button-next'
    );
    slidesPerView = slidesPerView === "auto" ? totalSlides : slidesPerView;

    if (totalSlides === slidesPerView) {
      navButtons.css("display", "none");
    } else {
      navButtons.css("display", "block");
    }
  }

  // Where to find us
  const locationSwiper = new Swiper(".swiper-locations-container", {
    loop: false,
    slidesPerView: 1,
    // spaceBetween: 10,
    slidesPerGroup: 1,

    autoplay: {
      delay: 2000,
    },
    pagination: {
      el: ".swiper-locations-container .swiper-pagination",
      clickable: true,
    },
    navigation: false,
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        // spaceBetween: 10,
      },
      1200: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        // spaceBetween: 20,
      },
    },
  });

  // Ingredients Slider New
  $(".ingredients-slider-wrapper .button").on("click", function () {
    $("body").css("overflow", "hidden");
    $(this)
      .closest(".ingredients-slider-wrapper")
      .next(".ingredients-popup-wrapper")
      .addClass("active");
  });

  $(".ingredients-popup .close-icon").on("click", function () {
    $("body").css("overflow", "visible");
    $(this).closest(".ingredients-popup-wrapper").removeClass("active");
  });

  $(".ingredients-slider-wrapper .ingredients").each(function () {
    let uniqueId = $(this).data("id");
    console.log("Initializing Swiper for ID:", uniqueId);
    const ingredientsSwiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: ".ingredients-swiper .next-" + uniqueId,
        prevEl: ".ingredients-swiper .prev-" + uniqueId,
      },
      loop: false,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3,
        },
      },
    });
  });

  // Differentiation Accordion
  $(".accordion-item").not(":first").find(".accordion-content").hide();
  $(".accordion-item").first().addClass("active");
  $(".accordion-item").first().find(".minus-icon").removeClass("active");
  $(".accordion-item").first().find(".plus-icon").addClass("active");

  $(".accordion-title").on("click", function () {
    let content = $(this).next(".accordion-content");

    if ($(this).parent().hasClass("active")) {
      content.slideUp();
      $(this).parent().removeClass("active");
      $(this).find(".minus-icon").addClass("active");
      $(this).find(".plus-icon").removeClass("active");
    } else {
      content.slideDown();
      $(this).parent().addClass("active");
      $(this).find(".minus-icon").removeClass("active");
      $(this).find(".plus-icon").addClass("active");

      $(".accordion-item")
        .not($(this).parent())
        .each(function () {
          $(this).removeClass("active");
          $(this).find(".accordion-content").slideUp();
          $(this).find(".minus-icon").addClass("active");
          $(this).find(".plus-icon").removeClass("active");
        });
    }
  });

  // Mind Body Booster section
  const boosterSwiper = new Swiper(".mind-body-booster__mobile-container", {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: ".mind-body-booster__mobile-container .swiper-pagination",
      clickable: true,
    },
  });

  // Product Slider
  // const productSwiperContainer = new Swiper(".product-swiper-container", {
  //   loop: true,
  //   slidesPerView: 1.5,
  //   spaceBetween: 20,
  //   pagination: {
  //     el: ".product-slider-wrapper .swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 2.5,
  //       pagination: {
  //         el: ".product-slider-wrapper .swiper-pagination",
  //         clickable: true,
  //       },
  //       navigation: false,
  //     },
  //     1300: {
  //       slidesPerView: 3.5,
  //       navigation: {
  //         prevEl: ".swiper-button-prev",
  //         nextEl: ".swiper-button-next",
  //       },
  //       pagination: false,
  //     },
  //   },
  // });

  $(".product-slider-wrapper").each(function () {
    var uniqueId = $(this).data("id"); // Get unique ID for the section

    // Initialize Swiper for each specific product slider section
    var productSwiperContainer = new Swiper(
      '.product-swiper-container[data-id="' + uniqueId + '"]',
      {
        loop: true,
        slidesPerView: 1.5,
        spaceBetween: 20,
        pagination: {
          el:
            '.product-slider-wrapper[data-id="' +
            uniqueId +
            '"] .swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.5,
            pagination: {
              el:
                '.product-slider-wrapper[data-id="' +
                uniqueId +
                '"] .swiper-pagination',
              clickable: true,
            },
            navigation: false,
          },
          1300: {
            slidesPerView: 3.5,
            navigation: {
              prevEl:
                '.product-slider-wrapper[data-id="' +
                uniqueId +
                '"] .swiper-button-prev',
              nextEl:
                '.product-slider-wrapper[data-id="' +
                uniqueId +
                '"] .swiper-button-next',
            },
            pagination: false,
          },
        },
      }
    );
  });

  // mani-slider-with-image--------------------
  // $(".mani-ingredients").each(function () {
  //   let uniqueId = $(this).data("id"); // Get unique ID from data attribute
  //   let slide = $(this).data("slide") + 0.5;

  //   let swiper = new Swiper(this, {
  //     slidesPerView: slide, // Show 3 full slides + a part of the 4th slide
  //     spaceBetween: 20,
  //     loop: true,
  //     slidesOffsetAfter: 30, // Adjust this value to control how much of the 4th slide is visible
  //     pagination: {
  //       el: ".swiper-pagination-" + uniqueId,
  //       clickable: true,
  //     },
  //     breakpoints: {
  //       1520: {
  //         slidesPerView: slide,
  //         spaceBetween: 20,
  //         navigation: {
  //           nextEl: ".next-" + uniqueId,
  //           prevEl: ".prev-" + uniqueId,
  //         },
  //         pagination: false,
  //       },
  //       1500: {
  //         slidesPerView: slide - 1,
  //         spaceBetween: 20,
  //         navigation: false, // Remove navigation
  //         pagination: {
  //           el: ".swiper-pagination-" + uniqueId,
  //           clickable: true,
  //         },
  //       },
  //       1024: {
  //         slidesPerView: 3.5,
  //         spaceBetween: 20,
  //         navigation: false,
  //         pagination: {
  //           el: ".swiper-pagination-" + uniqueId,
  //           clickable: true,
  //         },
  //       },
  //       768: {
  //         slidesPerView: 2.5,
  //         spaceBetween: 20,
  //         navigation: false,
  //         pagination: {
  //           el: ".swiper-pagination-" + uniqueId,
  //           clickable: true,
  //         },
  //       },
  //       320: {
  //         slidesPerView: 1.2,
  //         spaceBetween: 10,
  //         navigation: false,
  //         pagination: {
  //           el: ".swiper-pagination-" + uniqueId,
  //           clickable: true,
  //         },
  //       },
  //     },
  //   });
  // });

  $(".mani-ingredients").each(function () {
    let uniqueId = $(this).data("id");

    let swiper = new Swiper(this, {
      slidesPerView: 1.5,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination-" + uniqueId,
        clickable: true,
      },
      breakpoints: {
        565: {
          slidesPerView: 2,
          spaceBetween: 20,
          navigation: false,
          pagination: {
            el: ".swiper-pagination-" + uniqueId,
            clickable: true,
          },
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
          navigation: false,
          pagination: {
            el: ".swiper-pagination-" + uniqueId,
            clickable: true,
          },
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 20,
          navigation: false,
          pagination: {
            el: ".swiper-pagination-" + uniqueId,
            clickable: true,
          },
        },
        1300: {
          slidesPerView: 4,
          spaceBetween: 20,
          navigation: {
            nextEl: ".next-" + uniqueId,
            prevEl: ".prev-" + uniqueId,
          },
          pagination: false,
        },
      },
    });
  });
});
